module.exports = __webpack_public_path__ + "static/media/MentorKim.f62c93cd.jpeg";